import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  term: "" // empty means no filter
};

const daySlice = createSlice({
  name: "day",
  initialState,
  reducers: {
    UpdateDayTerm: (state, action) => {
      state.term = action.payload;
    },
    ClearDayTerm: (state) => {
      state.term = "";
    }
  }
});

export const { UpdateDayTerm, ClearDayTerm } = daySlice.actions;
export default daySlice.reducer;
